module.exports = __webpack_public_path__ + "static/media/map.ab675d63.png";